/**
 * For blue
 */
const jsBlur = () => {
  const bg = document.querySelector('.js-blur');

  if (!bg) return;
  window.addEventListener('scroll', () => {
    if (screen.width > 767) {
      if (document.documentElement.scrollTop > 340) {
        bg.classList.add('toggle');
      } else {
        bg.classList.remove('toggle');
      }
    } else {
      if (document.documentElement.scrollTop > 50) {
        bg.classList.add('toggle');
      } else {
        bg.classList.remove('toggle');
      }
    }
  });
};

export default jsBlur;